import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import CalculMensualiteCreditPage from "./pages/CalculMensualiteCreditPage";
import CalculCapaciteEmpruntPage from "./pages/CalculCapaciteEmpruntPage";
import EstimationFraisNotairePage from "./pages/EstimationFraisNotairePage";
import CalculRentabiliteLocativePage from "./pages/CalculRentabiliteLocativePage";
import CalculPlusValueImmobilierePage from "./pages/CalculPlusValueImmobilierePage";
import GenerateurAttestationHebergementPage from "./pages/GenerateurAttestationHebergementPage";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import PageWithSideBanners from "./components/PageWithSideBanners";
import CGU from "./pages/CGU";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <PageWithSideBanners>
        <main style={{ minHeight: "calc(100vh - 160px)" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />

            <Route
              path="/calcul-mensualite-credit"
              element={<CalculMensualiteCreditPage />}
            />
            <Route
              path="/calcul-capacite-emprunt"
              element={<CalculCapaciteEmpruntPage />}
            />
            <Route
              path="/estimation-frais-notaire"
              element={<EstimationFraisNotairePage />}
            />
            <Route
              path="/calcul-rentabilite-locative"
              element={<CalculRentabiliteLocativePage />}
            />
            <Route
              path="/calcul-plus-value-immobiliere"
              element={<CalculPlusValueImmobilierePage />}
            />
            <Route
              path="/generateur-attestation-hebergement"
              element={<GenerateurAttestationHebergementPage />}
            />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgu" element={<CGU />} />
          </Routes>
        </main>
      </PageWithSideBanners>
      <Footer />
    </BrowserRouter>
  );
}
